export default "__VITE_ASSET__401d2396__"